<template>
<div class="all">
    <v-header title="详情"></v-header>
    <div id="detail">
        <div class="conBox">
            <div v-html="html" style="padding: 0 15px"></div>    
        </div>
    </div>
</div>
</template>

<script>
import api from "../../modules/api"
import vHeader from '@/layout/Header1.vue'
export default {
    components: {vHeader},
    data(){
       return{
           html:''
       }
    },
    methods:{
        convert (htmlText) {
            let str = htmlText.replace(/<img[^>]*>/gi, function (match, capture) {
                let imgStyle = ''
                let wid = document.body.scrollWidth-30
                if(match.match(/width(\S*)/)){
                    let width = match.match(/width(\S*)/)[1].replace(/[=""]/g,'')
                    let height = match.match(/height(\S*)/)[1].replace(/[=""]/g,'')

                    let imgHeight = height/width * wid
                    imgStyle = 'style="width:'+ wid +'px;height:'+ imgHeight +'px"'
                }else {
                    imgStyle = 'style="width:'+ wid +'px"'
                }
                if(match.match(/style/)){
                    return match.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, imgStyle)
                }else{
                    let htmlTestLst = match.split('<img')
                    // return htmlTestLst.join('<img ' + imgStyle)
                    return htmlTestLst.join('<img ')
                }
                 // 替换style
            })
            return str

        },
        getDetail(){
            let that = this
            // alert(that.$route.query.id)
            let req = {
                id : that.$route.query.id
                // id: '63d409228f0847119986b78cacda42e8'
            }                          
            api.post(that.$url.getContent, req, function(res) {
                console.log(res)
                that.html = that.convert(res.data.pageContent)
                console.log(that.html,'123123')
            })
        }
    },
    watch:{
       
    },
    mounted(){
        // alert(1)
        this.getDetail()
    }
}
</script>

<style scoped>
.all {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /* background: #fff; */
}
#detail{
    height: calc(100% - 100px);
    width: 96%;
    margin: 0 auto;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    overflow: auto;
}
#detail::-webkit-scrollbar{width:2px;}
#detail::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);}
.conBox{
    height: 100%;
    /* overflow: auto; */
}
.conBox >>> img{
    max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/msg/detail.vue